import React, { useState } from 'react';
import jsPDF from 'jspdf';
import regresaBienFechaYDia from '../tools/regresaBienFechayDia';
import regresaBienFecha from '../tools/regresaBienFecha';
import comprueboPermisos from '../tools/comprueboPermisos';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import Modal from './Modal';
import GeneraPaseSalidaGrupalForm from './GeneraPaseSalidaGrupalForm';

const InfoModalDivision = ({ datos }) => {
  const Usuario = ObtieneDatosCookies();
  const [veoModalPase, setVeoModalPase] = useState(false);
// console.log(datos)
  // 🔒 Desestructuración segura
  const {
    divisionId,
    sede,
    FE = 0,
    FP = 0,
    FA = 0,
    FF = 0,
    Asistencia = [],
    cadetesAusentes = [],
    Guardia = [],
    numeroDivision,
    nombreDivision,
    divisionTexto,
    promocionId
  } = datos || {};

  const ordenarPorApellido = (a, b) =>
    (a["cadete.cadeteApellido"] || "").localeCompare(b["cadete.cadeteApellido"] || "");

  // 🔒 Arrays blindados
  const asistenciaOrdenada = Array.isArray(Asistencia)
    ? [...Asistencia].sort(ordenarPorApellido)
    : [];

  const guardiaOrdenada = Array.isArray(Guardia)
    ? [...Guardia].sort(ordenarPorApellido)
    : [];

  const ausentesOrdenados = Array.isArray(cadetesAusentes)
    ? [...cadetesAusentes].sort((a, b) =>
        (a.cadeteApellido || "").localeCompare(b.cadeteApellido || "")
      )
    : [];

 const exportarPDF = () => {
  const doc = new jsPDF();
  const fecha = new Date();

  let y = 15;

  // 🧾 ENCABEZADO
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);

  doc.text(
    divisionTexto || `División ${numeroDivision} - ${nombreDivision}`,
    105,
    y,
    { align: "center" }
  );

  y += 6;

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  doc.text(
    `Fecha: ${fecha.toLocaleDateString()} | Sede: ${sede}`,
    105,
    y,
    { align: "center" }
  );

  y += 8;

  // 📊 RESUMEN
  doc.setFont("helvetica", "bold");
  doc.text(
    `F.E: ${FE}   F.P: ${FP}   F.A: ${FA}   F.F: ${FF}`,
    105,
    y,
    { align: "center" }
  );

  y += 10;

  // 🔧 FUNCION AUXILIAR PARA BLOQUES
  const imprimirSeccion = (titulo, datos, color) => {
    if (!datos.length) return;

    if (y > 260) {
      doc.addPage();
      y = 15;
    }

    doc.setFont("helvetica", "bold");
    doc.setTextColor(...color);
    doc.text(titulo, 10, y);

    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    y += 5;

    datos.forEach((item, index) => {
      if (y > 270) {
        doc.addPage();
        y = 15;
      }

      doc.text(
        `${index + 1}. ${item.apellido.toUpperCase()}, ${item.nombre} - ${item.dni} ${item.extra || ""}`,
        10,
        y
      );

      y += 5;
    });

    y += 5;
  };

  // 🟢 ASISTENCIAS
  imprimirSeccion(
    "ASISTENCIAS",
    asistenciaOrdenada.map(a => ({
      apellido: a["cadete.cadeteApellido"] || "",
      nombre: a["cadete.cadeteNombre"] || "",
      dni: a.cadeteDni
    })),
    [0, 128, 0]
  );

  // 🟤 GUARDIA
  imprimirSeccion(
    "GUARDIA",
    guardiaOrdenada.map(g => ({
      apellido: g["cadete.cadeteApellido"] || "",
      nombre: g["cadete.cadeteNombre"] || "",
      dni: g.cadeteDni,
      extra: `| ${g.tipo}`
    })),
    [139, 69, 19]
  );

  // 🔴 AUSENTES
  imprimirSeccion(
    "AUSENTES",
    ausentesOrdenados.map(a => ({
      apellido: a.cadeteApellido || "",
      nombre: a.cadeteNombre || "",
      dni: a.cadeteDni,
      extra: `| ${a.tipoAusencia}`
    })),
    [200, 0, 0]
  );

  // 🪖 PIE
  doc.setFontSize(8);
  doc.setTextColor(100);
  doc.text(
    "Documento generado automáticamente - S.I.G.E.D.ISeP - DTyD 2026",
    105,
    290,
    { align: "center" }
  );

const blob = doc.output("blob");
const url = URL.createObjectURL(blob);
window.open(url, "_blank");
};  

  const generaPaseSalidaGrupal = () => {
    setVeoModalPase(!veoModalPase);
  };

  return (
    <>
      <div
        style={{
          padding: "20px",
          borderRadius: "10px",
          border: "1px solid #ddd",
          width: "800px",
          height: "500px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          overflow: "auto"
        }}
      >
        <h2>{divisionTexto || `División ${numeroDivision} - ${nombreDivision}`}</h2>
        <p><strong>Sede:</strong> {sede}</p>

        <div>
          <p>
            <strong>FE:</strong> {FE} &nbsp;
            <strong>FP:</strong> {FP} &nbsp;
            <strong>FA:</strong> {FA} &nbsp;
            <strong>FF:</strong> {FF}
          </p>
        </div>

        {comprueboPermisos(Usuario.funcion, "Pase Salida Grupal") &&
          asistenciaOrdenada.length > 0 && (
            <button onClick={generaPaseSalidaGrupal}>
              Generar Pase por División
            </button>
          )}

        {asistenciaOrdenada.length > 0 && (
          <div style={{ textAlign: "left" }}>
            <h4 style={{ color: "#889911" }}>Asistencias:</h4>
            <ul>
              {asistenciaOrdenada.map((asist, index) => (
                <li key={index}>
                  {index + 1}.{" "}
                  <strong>
                    {asist["cadete.cadeteApellido"]?.toUpperCase()},
                    {" "}
                    {asist["cadete.cadeteNombre"]}
                  </strong>{" "}
                  - {asist.cadeteDni}
                </li>
              ))}
            </ul>
          </div>
        )}

        {guardiaOrdenada.length > 0 && (
          <div style={{ textAlign: "left" }}>
            <h4 style={{ color: "brown" }}>Cadetes de Guardia</h4>
            <ul>
              {guardiaOrdenada.map((cadete, index) => (
                <li key={index}>
                  {index + 1}.{" "}
                  <strong>
                    {cadete["cadete.cadeteNombre"]}{" "}
                    {cadete["cadete.cadeteApellido"]?.toUpperCase()}
                  </strong>{" "}
                  - {cadete.cadeteDni} | Tipo: {cadete.tipo}
                </li>
              ))}
            </ul>
          </div>
        )}

        {ausentesOrdenados.length > 0 && (
          <div style={{ textAlign: "left" }}>
            <h4 style={{ color: "red" }}>Cadetes Ausentes</h4>
            <ul>
              {ausentesOrdenados.map((cadete, index) => (
                <li key={index}>
                  {index + 1}.{" "}
                  <strong>
                    {cadete.cadeteApellido?.toUpperCase()},
                  </strong>{" "}
                  {cadete.cadeteNombre} - {cadete.cadeteDni}{" "}
                  ({cadete.tipoAusencia})
                </li>
              ))}
            </ul>
          </div>
        )}

        <button
          onClick={exportarPDF}
          style={{
            marginTop: "20px",
            padding: "10px",
            backgroundColor: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          Exportar a PDF
        </button>
      </div>

      {veoModalPase && (
        <Modal isOpen={veoModalPase} onClose={() => setVeoModalPase(false)}>
          <div style={{ padding: "20px" }}>
            <h3>
              Generar Pase de Salida para {asistenciaOrdenada.length} cadetes?
            </h3>

            <GeneraPaseSalidaGrupalForm
              cadetes={asistenciaOrdenada}
              promocionId={promocionId}
              onClose={() => setVeoModalPase(false)}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default InfoModalDivision;